import { apiRequest } from 'lib/apiRequest'
const { get } = apiRequest

export const detections = {
  index: (token, params) => get(token, '/detections', params),
}
